import dayjs from 'dayjs';

/**
 * Hook to format timezone abbreviation from timezone string
 * Consolidates the repeated `timezone ? dayjs().tz(timezone).format('z') : ''` pattern
 */
export const useTimezoneDisplay = (timezone?: string) => {
  const tzAbbrev = timezone ? dayjs().tz(timezone).format('z') : '';
  return { tzAbbrev };
};
